"use strict";

angular.module("customer")
.controller("CustomerPaymentSettingsController", function(
    $scope, $stateParams, StateExtensionService, UserService, ModalService, PaymentMethodsService,
    CustomerPaymentSettingsService, PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES
) {
    $scope.isUserCanManagePaymentMethods = null;
    $scope.tabIndexes = {
        paymentMethods: 0,
        preAuthorized: 1,
    }
    $scope.PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES = PRE_AUTHORIZED_PAYMENT_AGREEMENT_TYPES;
    $scope.activeTab = $stateParams.tab ? parseInt($stateParams.tab) : $scope.tabIndexes.paymentMethods;
    StateExtensionService.updateUrlParams({tab: $scope.activeTab});
    $scope.currentActiveTab = null;
    $scope.preAuthorized = {
        hasMissingOptional: false,
        hasMissingMandatory: false
    }
    $scope.partnerships = null;
    $scope.methodChoicesLocalized = PaymentMethodsService.getMethodChoicesLocalized();

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
            $scope.isUserCanManagePaymentMethods = user.is_user_can_manage_payment_methods;
        }
        fetchPreAuthorizedTab();
    });

    $scope.$on("requestResetListing", function() {
        fetchPreAuthorizedTab();
    });

    function fetchPreAuthorizedTab() {
        if (!$scope.dedicatedVendorId && $scope.isUserCanManagePaymentMethods) {
            getPreAuthorizedPaymentMissingCount();

            CustomerPaymentSettingsService.getPreAuthorizedPaymentAgreements().then(function onSuccess(response) {
                if (response.data) {
                    $scope.partnerships = response.data;
                }
            });
        }
    }

    this.updateView = function(activeTab) {
        $scope.activeTab = activeTab;
        if ($scope.activeTab === $scope.currentActiveTab) {
            return;
        }
        $scope.currentActiveTab = $scope.activeTab;
        StateExtensionService.updateUrlParams({tab: $scope.activeTab});
    };

    function getPreAuthorizedPaymentMissingCount() {
        PaymentMethodsService.getPreAuthorizedPaymentMissingCount().then(function onSuccess(response) {
            if (response.data) {
                $scope.preAuthorized = {
                    hasMissingOptional: response.data.has_missing_optional,
                    hasMissingMandatory: response.data.has_missing_mandatory
                }
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/payment-settings/payment-settings.controller.js
// module id = 959
// module chunks = 0